import React, { useRef } from "react";
import * as PropTypes from "prop-types";
import AbsoluteChartToggleFrame from "../../widgets/AbsoluteChartToggleFrame";
import CumulativeGapByGniGroupChart from "./CumulativeGapByGniGroupChart";

const CumulativeGapByGniGroupChartWidget = props => {
  const ref = useRef();

  return (
    <AbsoluteChartToggleFrame
      dataViewerId="cumulative_gap_by_gni_group_chart"
      reference="Figure 1.4"
      title="Cumulative Gap by GNI Group, 2021–2025"
      subtitle="Comparison by Sector"
      contentWidth={400}
      initialAbsolute={false}
      chartRef={ref}
    >
      <CumulativeGapByGniGroupChart ref={ref} data={props.data} />
    </AbsoluteChartToggleFrame>
  );
};

CumulativeGapByGniGroupChartWidget.propTypes = {
  data: PropTypes.array.isRequired
};

export default CumulativeGapByGniGroupChartWidget;
